/** Trigger a runtime action belonging to an AppInstallation. */
export const appExecuteAction = {
    path: "/v2/app-installations/{appInstallationId}/actions/{action}",
    method: "POST",
    operationId: "app-execute-action",
};
/** Get an App. */
export const appGetApp = {
    path: "/v2/apps/{appId}",
    method: "GET",
    operationId: "app-get-app",
};
/** Get an AppInstallation. */
export const appGetAppinstallation = {
    path: "/v2/app-installations/{appInstallationId}",
    method: "GET",
    operationId: "app-get-appinstallation",
};
/** Trigger an uninstallation process for an AppInstallation. */
export const appUninstallAppinstallation = {
    path: "/v2/app-installations/{appInstallationId}",
    method: "DELETE",
    operationId: "app-uninstall-appinstallation",
};
/** Update properties belonging to an AppInstallation. */
export const appPatchAppinstallation = {
    path: "/v2/app-installations/{appInstallationId}",
    method: "PATCH",
    operationId: "app-patch-appinstallation",
};
/** Get an AppVersion. */
export const appGetAppversion = {
    path: "/v2/apps/{appId}/versions/{appVersionId}",
    method: "GET",
    operationId: "app-get-appversion",
};
/** Get the installed `SystemSoftware' for a specific `AppInstallation`. */
export const appGetInstalledSystemsoftwareForAppinstallation = {
    path: "/v2/app-installations/{appInstallationId}/systemSoftware",
    method: "GET",
    operationId: "app-get-installed-systemsoftware-for-appinstallation",
};
/** Get the missing requirements of an appInstallation for a specific target AppVersion. */
export const appGetMissingDependenciesForAppinstallation = {
    path: "/v2/app-installations/{appInstallationId}/missing-dependencies",
    method: "GET",
    operationId: "app-get-missing-dependencies-for-appinstallation",
};
/** Get a SystemSoftware. */
export const appGetSystemsoftware = {
    path: "/v2/system-softwares/{systemSoftwareId}",
    method: "GET",
    operationId: "app-get-systemsoftware",
};
/** Get a SystemSoftwareVersion. */
export const appGetSystemsoftwareversion = {
    path: "/v2/system-softwares/{systemSoftwareId}/versions/{systemSoftwareVersionId}",
    method: "GET",
    operationId: "app-get-systemsoftwareversion",
};
/** Create linkage between an AppInstallation and a MySQLDatabase. */
export const appLinkDatabase = {
    path: "/v2/app-installations/{appInstallationId}/database",
    method: "PATCH",
    operationId: "app-link-database",
};
/** List AppInstallations that a user has access to. */
export const appListAppinstallationsForUser = {
    path: "/v2/app-installations",
    method: "GET",
    operationId: "app-list-appinstallations-for-user",
};
/** List AppInstallations belonging to a Project. */
export const appListAppinstallations = {
    path: "/v2/projects/{projectId}/app-installations",
    method: "GET",
    operationId: "app-list-appinstallations",
};
/** Request an AppInstallation. */
export const appRequestAppinstallation = {
    path: "/v2/projects/{projectId}/app-installations",
    method: "POST",
    operationId: "app-request-appinstallation",
};
/** List Apps. */
export const appListApps = {
    path: "/v2/apps",
    method: "GET",
    operationId: "app-list-apps",
};
/** List AppVersions belonging to an App. */
export const appListAppversions = {
    path: "/v2/apps/{appId}/versions",
    method: "GET",
    operationId: "app-list-appversions",
};
/** List SystemSoftwares. */
export const appListSystemsoftwares = {
    path: "/v2/system-softwares",
    method: "GET",
    operationId: "app-list-systemsoftwares",
};
/** List SystemSoftwareVersions belonging to a SystemSoftware. */
export const appListSystemsoftwareversions = {
    path: "/v2/system-softwares/{systemSoftwareId}/versions",
    method: "GET",
    operationId: "app-list-systemsoftwareversions",
};
/** List update candidates belonging to an AppVersion. */
export const appListUpdateCandidatesForAppversion = {
    path: "/v2/apps/{appId}/versions/{baseAppVersionId}/update-candidates",
    method: "GET",
    operationId: "app-list-update-candidates-for-appversion",
};
/** Replace a MySQL Database with another MySQL Database. */
export const appReplaceDatabase = {
    path: "/v2/app-installations/{appInstallationId}/database/replace",
    method: "PATCH",
    operationId: "app-replace-database",
};
/** Request a copy of an AppInstallation. */
export const appRequestAppinstallationCopy = {
    path: "/v2/app-installations/{appInstallationId}/actions/copy",
    method: "POST",
    operationId: "app-request-appinstallation-copy",
};
/** Get runtime status belonging to an AppInstallation. */
export const appRetrieveStatus = {
    path: "/v2/app-installations/{appInstallationId}/status",
    method: "GET",
    operationId: "app-retrieve-status",
};
/** Remove linkage between an AppInstallation and a Database. */
export const appUnlinkDatabase = {
    path: "/v2/app-installations/{appInstallationId}/databases/{databaseId}",
    method: "DELETE",
    operationId: "app-unlink-database",
};
/** Create linkage between an AppInstallation and DatabaseUsers. */
export const appSetDatabaseUsers = {
    path: "/v2/app-installations/{appInstallationId}/databases/{databaseId}/users",
    method: "PUT",
    operationId: "app-set-database-users",
};
/** Get an Article. */
export const articleGetArticle = {
    path: "/v2/articles/{articleId}",
    method: "GET",
    operationId: "article-get-article",
};
/** List Articles. */
export const articleListArticles = {
    path: "/v2/articles",
    method: "GET",
    operationId: "article-list-articles",
};
/** Export a ProjectBackup for download. */
export const backupCreateProjectBackupExport = {
    path: "/v2/project-backups/{projectBackupId}/export",
    method: "POST",
    operationId: "backup-create-project-backup-export",
};
/** Delete a ProjectBackupExport. */
export const backupDeleteProjectBackupExport = {
    path: "/v2/project-backups/{projectBackupId}/export",
    method: "DELETE",
    operationId: "backup-delete-project-backup-export",
};
/** List BackupSchedules belonging to a Project. */
export const backupListProjectBackupSchedules = {
    path: "/v2/projects/{projectId}/backup-schedules",
    method: "GET",
    operationId: "backup-list-project-backup-schedules",
};
/** Create a BackupSchedule for a Project. */
export const backupCreateProjectBackupSchedule = {
    path: "/v2/projects/{projectId}/backup-schedules",
    method: "POST",
    operationId: "backup-create-project-backup-schedule",
};
/** List Backups belonging to a Project. */
export const backupListProjectBackups = {
    path: "/v2/projects/{projectId}/backups",
    method: "GET",
    operationId: "backup-list-project-backups",
};
/** Create a Backup of a Project. */
export const backupCreateProjectBackup = {
    path: "/v2/projects/{projectId}/backups",
    method: "POST",
    operationId: "backup-create-project-backup",
};
/** Get a ProjectBackupSchedule. */
export const backupGetProjectBackupSchedule = {
    path: "/v2/project-backup-schedules/{projectBackupScheduleId}",
    method: "GET",
    operationId: "backup-get-project-backup-schedule",
};
/** Delete a ProjectBackupSchedule. */
export const backupDeleteProjectBackupSchedule = {
    path: "/v2/project-backup-schedules/{projectBackupScheduleId}",
    method: "DELETE",
    operationId: "backup-delete-project-backup-schedule",
};
/** Update a ProjectBackupSchedule. */
export const backupUpdateProjectBackupSchedule = {
    path: "/v2/project-backup-schedules/{projectBackupScheduleId}",
    method: "PATCH",
    operationId: "backup-update-project-backup-schedule",
};
/** Get a ProjectBackup. */
export const backupGetProjectBackup = {
    path: "/v2/project-backups/{projectBackupId}",
    method: "GET",
    operationId: "backup-get-project-backup",
};
/** Delete a ProjectBackup. */
export const backupDeleteProjectBackup = {
    path: "/v2/project-backups/{projectBackupId}",
    method: "DELETE",
    operationId: "backup-delete-project-backup",
};
/** Change the description of a ProjectBackup. */
export const backupUpdateProjectBackupDescription = {
    path: "/v2/project-backups/{projectBackupId}/description",
    method: "PATCH",
    operationId: "backup-update-project-backup-description",
};
/** List Registries belonging to a Project. */
export const containerListRegistries = {
    path: "/v2/projects/{projectId}/registries",
    method: "GET",
    operationId: "container-list-registries",
};
/** Create a Registry. */
export const containerCreateRegistry = {
    path: "/v2/projects/{projectId}/registries",
    method: "POST",
    operationId: "container-create-registry",
};
/** Get a Stack. */
export const containerGetStack = {
    path: "/v2/stacks/{stackId}",
    method: "GET",
    operationId: "container-get-stack",
};
/** Declaratively create, update or delete Services or Volumes belonging to a Stack. */
export const containerDeclareStack = {
    path: "/v2/stacks/{stackId}",
    method: "PUT",
    operationId: "container-declare-stack",
};
/** Create, update or delete Services or Volumes belonging to a Stack. */
export const containerUpdateStack = {
    path: "/v2/stacks/{stackId}",
    method: "PATCH",
    operationId: "container-update-stack",
};
/** Get a Registry. */
export const containerGetRegistry = {
    path: "/v2/registries/{registryId}",
    method: "GET",
    operationId: "container-get-registry",
};
/** Delete a Registry. */
export const containerDeleteRegistry = {
    path: "/v2/registries/{registryId}",
    method: "DELETE",
    operationId: "container-delete-registry",
};
/** Update a Registry. */
export const containerUpdateRegistry = {
    path: "/v2/registries/{registryId}",
    method: "PATCH",
    operationId: "container-update-registry",
};
/** Get a Volume belonging to a Stack. */
export const containerGetVolume = {
    path: "/v2/stacks/{stackId}/volumes/{volumeId}",
    method: "GET",
    operationId: "container-get-volume",
};
/** Delete a Volume belonging to a Stack. */
export const containerDeleteVolume = {
    path: "/v2/stacks/{stackId}/volumes/{volumeId}",
    method: "DELETE",
    operationId: "container-delete-volume",
};
/** Get a ContainerImageConfig. */
export const containerGetContainerImageConfig = {
    path: "/v2/container-image-config",
    method: "GET",
    operationId: "container-get-container-image-config",
};
/** Get logs belonging to a Service. */
export const containerGetServiceLogs = {
    path: "/v2/stacks/{stackId}/services/{serviceId}/logs",
    method: "GET",
    operationId: "container-get-service-logs",
};
/** Get a Service belonging to a Stack. */
export const containerGetService = {
    path: "/v2/stacks/{stackId}/services/{serviceId}",
    method: "GET",
    operationId: "container-get-service",
};
/** List Services belonging to a Project. */
export const containerListServices = {
    path: "/v2/projects/{projectId}/services",
    method: "GET",
    operationId: "container-list-services",
};
/** List Stacks belonging to a Project. */
export const containerListStacks = {
    path: "/v2/projects/{projectId}/stacks",
    method: "GET",
    operationId: "container-list-stacks",
};
/** List Volumes belonging to a Project. */
export const containerListVolumes = {
    path: "/v2/projects/{projectId}/volumes",
    method: "GET",
    operationId: "container-list-volumes",
};
/** Pulls the latest version of the Service's image and recreates the Service. */
export const containerPullImageForService = {
    path: "/v2/stacks/{stackId}/services/{serviceId}/actions/pull",
    method: "POST",
    operationId: "container-pull-image-for-service",
};
/** Recreate a Service. */
export const containerRecreateService = {
    path: "/v2/stacks/{stackId}/services/{serviceId}/actions/recreate",
    method: "POST",
    operationId: "container-recreate-service",
};
/** Restart a started Service. */
export const containerRestartService = {
    path: "/v2/stacks/{stackId}/services/{serviceId}/actions/restart",
    method: "POST",
    operationId: "container-restart-service",
};
/** Start a stopped Service. */
export const containerStartService = {
    path: "/v2/stacks/{stackId}/services/{serviceId}/actions/start",
    method: "POST",
    operationId: "container-start-service",
};
/** Stop a started Service. */
export const containerStopService = {
    path: "/v2/stacks/{stackId}/services/{serviceId}/actions/stop",
    method: "POST",
    operationId: "container-stop-service",
};
/** Validate a Registries' URI. */
export const containerValidateContainerRegistryUri = {
    path: "/v2/actions/validate-container-registry-uri",
    method: "POST",
    operationId: "container-validate-container-registry-uri",
};
/** Validate a Registries' credentials. */
export const containerValidateRegistryCredentials = {
    path: "/v2/registries/{registryId}/actions/validate-credentials",
    method: "POST",
    operationId: "container-validate-registry-credentials",
};
/** Schedule the Termination of a ContractItem. */
export const contractTerminateContractItem = {
    path: "/v2/contracts/{contractId}/items/{contractItemId}/termination",
    method: "POST",
    operationId: "contract-terminate-contract-item",
};
/** Cancel the Termination for the referred ContractItem. */
export const contractCancelContractItemTermination = {
    path: "/v2/contracts/{contractId}/items/{contractItemId}/termination",
    method: "DELETE",
    operationId: "contract-cancel-contract-item-termination",
};
/** Cancel the TariffChange for the referred ContractItem. */
export const contractCancelContractTariffChange = {
    path: "/v2/contracts/{contractId}/items/{contractItemId}/tariff-change",
    method: "DELETE",
    operationId: "contract-cancel-contract-tariff-change",
};
/** Schedule the Termination of a Contract. */
export const contractTerminateContract = {
    path: "/v2/contracts/{contractId}/termination",
    method: "POST",
    operationId: "contract-terminate-contract",
};
/** Cancel the Termination for the referred Contract. */
export const contractCancelContractTermination = {
    path: "/v2/contracts/{contractId}/termination",
    method: "DELETE",
    operationId: "contract-cancel-contract-termination",
};
/** Return the BaseItem of the Contract with the given ID. */
export const contractGetBaseItemOfContract = {
    path: "/v2/contracts/{contractId}/base-items",
    method: "GET",
    operationId: "contract-get-base-item-of-contract",
};
/** Return the Contract for the given Certificate. */
export const contractGetDetailOfContractByCertificate = {
    path: "/v2/certificates/{certificateId}/contract",
    method: "GET",
    operationId: "contract-get-detail-of-contract-by-certificate",
};
/** Return the Contract for the given Domain. */
export const contractGetDetailOfContractByDomain = {
    path: "/v2/domains/{domainId}/contract",
    method: "GET",
    operationId: "contract-get-detail-of-contract-by-domain",
};
/** Return the Contract for the given LeadFyndrProfile. */
export const contractGetDetailOfContractByLeadFyndr = {
    path: "/v2/customers/{customerId}/lead-fyndr-profile/contract",
    method: "GET",
    operationId: "contract-get-detail-of-contract-by-lead-fyndr",
};
/** Return the Contract for the given Project. */
export const contractGetDetailOfContractByProject = {
    path: "/v2/projects/{projectId}/contract",
    method: "GET",
    operationId: "contract-get-detail-of-contract-by-project",
};
/** Return the Contract for the given Server. */
export const contractGetDetailOfContractByServer = {
    path: "/v2/servers/{serverId}/contract",
    method: "GET",
    operationId: "contract-get-detail-of-contract-by-server",
};
/** Get the ContractItem with the given ID. */
export const contractGetDetailOfContractItem = {
    path: "/v2/contracts/{contractId}/items/{contractItemId}",
    method: "GET",
    operationId: "contract-get-detail-of-contract-item",
};
/** Returns the Contract with the given ID. */
export const contractGetDetailOfContract = {
    path: "/v2/contracts/{contractId}",
    method: "GET",
    operationId: "contract-get-detail-of-contract",
};
/** Return the next TerminationDate for the ContractItem with the given ID. */
export const contractGetNextTerminationDateForItem = {
    path: "/v2/contracts/{contractId}/items/{contractItemId}/next-termination-dates",
    method: "GET",
    operationId: "contract-get-next-termination-date-for-item",
};
/** Return a list of Contracts for the given Customer. */
export const contractListContracts = {
    path: "/v2/customers/{customerId}/contracts",
    method: "GET",
    operationId: "contract-list-contracts",
};
/** Get Contributor Billing Information. */
export const contributorGetBillingInformation = {
    path: "/v2/contributors/{contributorId}/billing-information",
    method: "GET",
    operationId: "contributor-get-billing-information",
};
/** Update Contributor Billing Information. */
export const contributorUpdateBillingInformation = {
    path: "/v2/contributors/{contributorId}/billing-information",
    method: "PUT",
    operationId: "contributor-update-billing-information",
};
/** Get the Stripe Billing Portal Link for a Customer */
export const contributorGetCustomerBillingPortalLink = {
    path: "/v2/customers/{customerId}/billing-portal",
    method: "GET",
    operationId: "contributor-get-customer-billing-portal-link",
};
/** Get the Stripe Dashboard Link for a Contributor. */
export const contributorGetLoginLink = {
    path: "/v2/contributors/{contributorId}/dashboard",
    method: "GET",
    operationId: "contributor-get-login-link",
};
/** List all invoices on behalf of a contributor. */
export const contributorListOnbehalfInvoices = {
    path: "/v2/contributors/{contributorId}/invoices/outgoing",
    method: "GET",
    operationId: "contributor-list-onbehalf-invoices",
};
/** Rotate the secret for an extension instance. */
export const contributorRotateSecretForExtensionInstance = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/extension-instances/{extensionInstanceId}/secret",
    method: "PUT",
    operationId: "contributor-rotate-secret-for-extension-instance",
};
/** Get all conversation the authenticated user has created or has access to. */
export const conversationListConversations = {
    path: "/v2/conversations",
    method: "GET",
    operationId: "conversation-list-conversations",
};
/** Create a conversation. */
export const conversationCreateConversation = {
    path: "/v2/conversations",
    method: "POST",
    operationId: "conversation-create-conversation",
};
/** Get all message of the conversation. */
export const conversationListMessagesByConversation = {
    path: "/v2/conversations/{conversationId}/messages",
    method: "GET",
    operationId: "conversation-list-messages-by-conversation",
};
/** Send a new message in the conversation. */
export const conversationCreateMessage = {
    path: "/v2/conversations/{conversationId}/messages",
    method: "POST",
    operationId: "conversation-create-message",
};
/** Get a specific conversation category. */
export const conversationGetCategory = {
    path: "/v2/conversation-categories/{categoryId}",
    method: "GET",
    operationId: "conversation-get-category",
};
/** Get members of a support conversation. */
export const conversationGetConversationMembers = {
    path: "/v2/conversations/{conversationId}/members",
    method: "GET",
    operationId: "conversation-get-conversation-members",
};
/** Get preferences for customer conversations. */
export const conversationGetConversationPreferencesOfCustomer = {
    path: "/v2/customers/{customerId}/conversation-preferences",
    method: "GET",
    operationId: "conversation-get-conversation-preferences-of-customer",
};
/** Get a support conversation. */
export const conversationGetConversation = {
    path: "/v2/conversations/{conversationId}",
    method: "GET",
    operationId: "conversation-get-conversation",
};
/** Update the basic properties of the conversation. */
export const conversationUpdateConversation = {
    path: "/v2/conversations/{conversationId}",
    method: "PUT",
    operationId: "conversation-update-conversation",
};
/** Request an access token for the File belonging to the Conversation. */
export const conversationGetFileAccessToken = {
    path: "/v2/conversations/{conversationId}/files/{fileId}/access-token",
    method: "GET",
    operationId: "conversation-get-file-access-token",
};
/** Get all conversation categories. */
export const conversationListCategories = {
    path: "/v2/conversation-categories",
    method: "GET",
    operationId: "conversation-list-categories",
};
/** Request a file upload token for the conversation. */
export const conversationRequestFileUpload = {
    path: "/v2/conversations/{conversationId}/files",
    method: "POST",
    operationId: "conversation-request-file-upload",
};
/** Update the status of a conversation. */
export const conversationSetConversationStatus = {
    path: "/v2/conversations/{conversationId}/status",
    method: "PUT",
    operationId: "conversation-set-conversation-status",
};
/** Update the content of the message */
export const conversationUpdateMessage = {
    path: "/v2/conversations/{conversationId}/messages/{messageId}",
    method: "PATCH",
    operationId: "conversation-update-message",
};
/** Abort a CronjobExecution. */
export const cronjobAbortExecution = {
    path: "/v2/cronjobs/{cronjobId}/executions/{executionId}/actions/abort",
    method: "POST",
    operationId: "cronjob-abort-execution",
};
/** List Cronjobs belonging to a Project. */
export const cronjobListCronjobs = {
    path: "/v2/projects/{projectId}/cronjobs",
    method: "GET",
    operationId: "cronjob-list-cronjobs",
};
/** Create a Cronjob. */
export const cronjobCreateCronjob = {
    path: "/v2/projects/{projectId}/cronjobs",
    method: "POST",
    operationId: "cronjob-create-cronjob",
};
/** List CronjobExecutions belonging to a Cronjob. */
export const cronjobListExecutions = {
    path: "/v2/cronjobs/{cronjobId}/executions",
    method: "GET",
    operationId: "cronjob-list-executions",
};
/** Trigger a Cronjob. */
export const cronjobCreateExecution = {
    path: "/v2/cronjobs/{cronjobId}/executions",
    method: "POST",
    operationId: "cronjob-create-execution",
};
/** Get a Cronjob. */
export const cronjobGetCronjob = {
    path: "/v2/cronjobs/{cronjobId}",
    method: "GET",
    operationId: "cronjob-get-cronjob",
};
/** Delete a Cronjob. */
export const cronjobDeleteCronjob = {
    path: "/v2/cronjobs/{cronjobId}",
    method: "DELETE",
    operationId: "cronjob-delete-cronjob",
};
/** Update a Cronjob. */
export const cronjobUpdateCronjob = {
    path: "/v2/cronjobs/{cronjobId}",
    method: "PATCH",
    operationId: "cronjob-update-cronjob",
};
/** Get a CronjobExecution. */
export const cronjobGetExecution = {
    path: "/v2/cronjobs/{cronjobId}/executions/{executionId}",
    method: "GET",
    operationId: "cronjob-get-execution",
};
/** Update a Cronjob's app id. */
export const cronjobUpdateCronjobAppId = {
    path: "/v2/cronjobs/{cronjobId}/app-id",
    method: "PATCH",
    operationId: "cronjob-update-cronjob-app-id",
};
/** Accept a CustomerInvite. */
export const customerAcceptCustomerInvite = {
    path: "/v2/customer-invites/{customerInviteId}/actions/accept",
    method: "POST",
    operationId: "customer-accept-customer-invite",
};
/** List Invites belonging to a Customer. */
export const customerListInvitesForCustomer = {
    path: "/v2/customers/{customerId}/invites",
    method: "GET",
    operationId: "customer-list-invites-for-customer",
};
/** Create a CustomerInvite. */
export const customerCreateCustomerInvite = {
    path: "/v2/customers/{customerId}/invites",
    method: "POST",
    operationId: "customer-create-customer-invite",
};
/** Get all customer profiles the authenticated user has access to. */
export const customerListCustomers = {
    path: "/v2/customers",
    method: "GET",
    operationId: "customer-list-customers",
};
/** Create a new customer profile. */
export const customerCreateCustomer = {
    path: "/v2/customers",
    method: "POST",
    operationId: "customer-create-customer",
};
/** Lets us know your idea for our recommendation programm. */
export const customerCreateRecommendationSuggestion = {
    path: "/v2/customers/{customerId}/recommendation-suggestions",
    method: "POST",
    operationId: "customer-create-recommendation-suggestion",
};
/** Gets the Wallet of the Customer. */
export const customerGetWallet = {
    path: "/v2/customers/{customerId}/wallet",
    method: "GET",
    operationId: "customer-get-wallet",
};
/** Create the Wallet for the Customer. */
export const customerCreateWallet = {
    path: "/v2/customers/{customerId}/wallet",
    method: "POST",
    operationId: "customer-create-wallet",
};
/** Decline a CustomerInvite. */
export const customerDeclineCustomerInvite = {
    path: "/v2/customer-invites/{customerInviteId}/actions/decline",
    method: "POST",
    operationId: "customer-decline-customer-invite",
};
/** Get a CustomerInvite. */
export const customerGetCustomerInvite = {
    path: "/v2/customer-invites/{customerInviteId}",
    method: "GET",
    operationId: "customer-get-customer-invite",
};
/** Delete a CustomerInvite. */
export const customerDeleteCustomerInvite = {
    path: "/v2/customer-invites/{customerInviteId}",
    method: "DELETE",
    operationId: "customer-delete-customer-invite",
};
/** Get a CustomerMembership. */
export const customerGetCustomerMembership = {
    path: "/v2/customer-memberships/{customerMembershipId}",
    method: "GET",
    operationId: "customer-get-customer-membership",
};
/** Delete a CustomerMembership. */
export const customerDeleteCustomerMembership = {
    path: "/v2/customer-memberships/{customerMembershipId}",
    method: "DELETE",
    operationId: "customer-delete-customer-membership",
};
/** Update a CustomerMembership. */
export const customerUpdateCustomerMembership = {
    path: "/v2/customer-memberships/{customerMembershipId}",
    method: "PATCH",
    operationId: "customer-update-customer-membership",
};
/** Get a customer profile. */
export const customerGetCustomer = {
    path: "/v2/customers/{customerId}",
    method: "GET",
    operationId: "customer-get-customer",
};
/** Update a customer profile. */
export const customerUpdateCustomer = {
    path: "/v2/customers/{customerId}",
    method: "PUT",
    operationId: "customer-update-customer",
};
/** Delete a customer profile. */
export const customerDeleteCustomer = {
    path: "/v2/customers/{customerId}",
    method: "DELETE",
    operationId: "customer-delete-customer",
};
/** Get a CustomerInvite by token. */
export const customerGetCustomerTokenInvite = {
    path: "/v2/customer-token-invite",
    method: "GET",
    operationId: "customer-get-customer-token-invite",
};
/** Check if the customer profile has a valid contract partner configured. */
export const customerIsCustomerLegallyCompetent = {
    path: "/v2/customers/{customerId}/legally-competent",
    method: "GET",
    operationId: "customer-is-customer-legally-competent",
};
/** List CustomerInvites belonging to the executing user. */
export const customerListCustomerInvites = {
    path: "/v2/customer-invites",
    method: "GET",
    operationId: "customer-list-customer-invites",
};
/** List CustomerMemberships belonging to the executing user. */
export const customerListCustomerMemberships = {
    path: "/v2/customer-memberships",
    method: "GET",
    operationId: "customer-list-customer-memberships",
};
/** List Memberships belonging to a Customer. */
export const customerListMembershipsForCustomer = {
    path: "/v2/customers/{customerId}/memberships",
    method: "GET",
    operationId: "customer-list-memberships-for-customer",
};
/** Request a new avatar upload for the customer profile. */
export const customerRequestAvatarUpload = {
    path: "/v2/customers/{customerId}/avatar",
    method: "POST",
    operationId: "customer-request-avatar-upload",
};
/** Remove the avatar picture of the customer profile. */
export const customerRemoveAvatar = {
    path: "/v2/customers/{customerId}/avatar",
    method: "DELETE",
    operationId: "customer-remove-avatar",
};
/** Resend the mail for a CustomerInvite. */
export const customerResendCustomerInviteMail = {
    path: "/v2/customer-invites/{customerInviteId}/actions/resend",
    method: "POST",
    operationId: "customer-resend-customer-invite-mail",
};
/** List MySQLDatabases belonging to a Project. */
export const databaseListMysqlDatabases = {
    path: "/v2/projects/{projectId}/mysql-databases",
    method: "GET",
    operationId: "database-list-mysql-databases",
};
/** Create a MySQLDatabase with a MySQLUser. */
export const databaseCreateMysqlDatabase = {
    path: "/v2/projects/{projectId}/mysql-databases",
    method: "POST",
    operationId: "database-create-mysql-database",
};
/** List MySQLUsers belonging to a Database. */
export const databaseListMysqlUsers = {
    path: "/v2/mysql-databases/{mysqlDatabaseId}/users",
    method: "GET",
    operationId: "database-list-mysql-users",
};
/** Create a MySQLUser. */
export const databaseCreateMysqlUser = {
    path: "/v2/mysql-databases/{mysqlDatabaseId}/users",
    method: "POST",
    operationId: "database-create-mysql-user",
};
/** List RedisDatabases belonging to a Project. */
export const databaseListRedisDatabases = {
    path: "/v2/projects/{projectId}/redis-databases",
    method: "GET",
    operationId: "database-list-redis-databases",
};
/** Create a RedisDatabase. */
export const databaseCreateRedisDatabase = {
    path: "/v2/projects/{projectId}/redis-databases",
    method: "POST",
    operationId: "database-create-redis-database",
};
/** Get a MySQLDatabase. */
export const databaseGetMysqlDatabase = {
    path: "/v2/mysql-databases/{mysqlDatabaseId}",
    method: "GET",
    operationId: "database-get-mysql-database",
};
/** Delete a MySQLDatabase. */
export const databaseDeleteMysqlDatabase = {
    path: "/v2/mysql-databases/{mysqlDatabaseId}",
    method: "DELETE",
    operationId: "database-delete-mysql-database",
};
/** Get a MySQLUser. */
export const databaseGetMysqlUser = {
    path: "/v2/mysql-users/{mysqlUserId}",
    method: "GET",
    operationId: "database-get-mysql-user",
};
/** Update a MySQLUser. */
export const databaseUpdateMysqlUser = {
    path: "/v2/mysql-users/{mysqlUserId}",
    method: "PUT",
    operationId: "database-update-mysql-user",
};
/** Delete a MySQLUser. */
export const databaseDeleteMysqlUser = {
    path: "/v2/mysql-users/{mysqlUserId}",
    method: "DELETE",
    operationId: "database-delete-mysql-user",
};
/** Get a RedisDatabase. */
export const databaseGetRedisDatabase = {
    path: "/v2/redis-databases/{redisDatabaseId}",
    method: "GET",
    operationId: "database-get-redis-database",
};
/** Delete a RedisDatabase. */
export const databaseDeleteRedisDatabase = {
    path: "/v2/redis-databases/{redisDatabaseId}",
    method: "DELETE",
    operationId: "database-delete-redis-database",
};
/** Disable a MySQLUser. */
export const databaseDisableMysqlUser = {
    path: "/v2/mysql-users/{mysqlUserId}/actions/disable",
    method: "POST",
    operationId: "database-disable-mysql-user",
};
/** Enable a MySQLUser. */
export const databaseEnableMysqlUser = {
    path: "/v2/mysql-users/{mysqlUserId}/actions/enable",
    method: "POST",
    operationId: "database-enable-mysql-user",
};
/** Get a MySQLUser's PhpMyAdmin-URL. */
export const databaseGetMysqlUserPhpMyAdminUrl = {
    path: "/v2/mysql-users/{mysqlUserId}/php-my-admin-url",
    method: "GET",
    operationId: "database-get-mysql-user-php-my-admin-url",
};
/** List available MySQL character sets and collations, optionally filtered by a MySQLVersion. */
export const databaseListMysqlCharsets = {
    path: "/v2/mysql-charsets",
    method: "GET",
    operationId: "database-list-mysql-charsets",
};
/** List MySQLVersions. */
export const databaseListMysqlVersions = {
    path: "/v2/mysql-versions",
    method: "GET",
    operationId: "database-list-mysql-versions",
};
/** List RedisVersions. */
export const databaseListRedisVersions = {
    path: "/v2/redis-versions",
    method: "GET",
    operationId: "database-list-redis-versions",
};
/** Update a MySQLDatabase's default character settings. */
export const databaseUpdateMysqlDatabaseDefaultCharset = {
    path: "/v2/mysql-databases/{mysqlDatabaseId}/default-charset",
    method: "PATCH",
    operationId: "database-update-mysql-database-default-charset",
};
/** Update a MySQLDatabase's description. */
export const databaseUpdateMysqlDatabaseDescription = {
    path: "/v2/mysql-databases/{mysqlDatabaseId}/description",
    method: "PATCH",
    operationId: "database-update-mysql-database-description",
};
/** Update a MySQLUser's password. */
export const databaseUpdateMysqlUserPassword = {
    path: "/v2/mysql-users/{mysqlUserId}/password",
    method: "PATCH",
    operationId: "database-update-mysql-user-password",
};
/** Update a RedisDatabase's configuration. */
export const databaseUpdateRedisDatabaseConfiguration = {
    path: "/v2/redis-databases/{redisDatabaseId}/configuration",
    method: "PATCH",
    operationId: "database-update-redis-database-configuration",
};
/** Update a RedisDatabase's description. */
export const databaseUpdateRedisDatabaseDescription = {
    path: "/v2/redis-databases/{redisDatabaseId}/description",
    method: "PATCH",
    operationId: "database-update-redis-database-description",
};
/** List Domains */
export const domainListDomains = {
    path: "/v2/domains",
    method: "GET",
    operationId: "domain-list-domains",
};
/** Update the nameservers of a Domain. */
export const domainUpdateDomainNameservers = {
    path: "/v2/domains/{domainId}/nameservers",
    method: "PATCH",
    operationId: "domain-update-domain-nameservers",
};
/** Update the paths of an Ingress. */
export const ingressUpdateIngressPaths = {
    path: "/v2/ingresses/{ingressId}/paths",
    method: "PATCH",
    operationId: "ingress-update-ingress-paths",
};
/** Update the tls settings of an Ingress. */
export const ingressUpdateIngressTls = {
    path: "/v2/ingresses/{ingressId}/tls",
    method: "PATCH",
    operationId: "ingress-update-ingress-tls",
};
/** Update the autoresponder of a MailAddress. */
export const mailUpdateMailAddressAutoresponder = {
    path: "/v2/mail-addresses/{mailAddressId}/autoresponder",
    method: "PATCH",
    operationId: "mail-update-mail-address-autoresponder",
};
/** Update the forward addresses of a MailAddresses. */
export const mailUpdateMailAddressForwardAddresses = {
    path: "/v2/mail-addresses/{mailAddressId}/forward-addresses",
    method: "PATCH",
    operationId: "mail-update-mail-address-forward-addresses",
};
/** Update the password for a MailAddress. */
export const mailUpdateMailAddressPassword = {
    path: "/v2/mail-addresses/{mailAddressId}/password",
    method: "PATCH",
    operationId: "mail-update-mail-address-password",
};
/** Update the quota of a MailAddress. */
export const mailUpdateMailAddressQuota = {
    path: "/v2/mail-addresses/{mailAddressId}/quota",
    method: "PATCH",
    operationId: "mail-update-mail-address-quota",
};
/** Update the spam protection of a MailAddress. */
export const mailUpdateMailAddressSpamProtection = {
    path: "/v2/mail-addresses/{mailAddressId}/spam-protection",
    method: "PATCH",
    operationId: "mail-update-mail-address-spam-protection",
};
/** Subscribe a user to the mStudio newsletter. */
export const newsletterSubscribeUser = {
    path: "/v2/newsletter-subscriptions",
    method: "POST",
    operationId: "newsletter-subscribe-user",
};
/** Update your account information. */
export const userUpdateAccount = {
    path: "/v2/users/self/personal-information",
    method: "PUT",
    operationId: "user-update-account",
};
/** Create a DNSZone. */
export const dnsCreateDnsZone = {
    path: "/v2/dns-zones",
    method: "POST",
    operationId: "dns-create-dns-zone",
};
/** Get a DNSZone. */
export const dnsGetDnsZone = {
    path: "/v2/dns-zones/{dnsZoneId}",
    method: "GET",
    operationId: "dns-get-dns-zone",
};
/** Delete a DNSZone. */
export const dnsDeleteDnsZone = {
    path: "/v2/dns-zones/{dnsZoneId}",
    method: "DELETE",
    operationId: "dns-delete-dns-zone",
};
/** List DNSZones belonging to a Project. */
export const dnsListDnsZones = {
    path: "/v2/projects/{projectId}/dns-zones",
    method: "GET",
    operationId: "dns-list-dns-zones",
};
/** Set a record set on a DNSZone to managed. */
export const dnsSetRecordSetManaged = {
    path: "/v2/dns-zones/{dnsZoneId}/record-sets/{recordSet}/actions/set-managed",
    method: "POST",
    operationId: "dns-set-record-set-managed",
};
/** Update a record set on a DNSZone. */
export const dnsUpdateRecordSet = {
    path: "/v2/dns-zones/{dnsZoneId}/record-sets/{recordSet}",
    method: "PUT",
    operationId: "dns-update-record-set",
};
/** Abort a Domain declaration. */
export const domainAbortDomainDeclaration = {
    path: "/v2/domains/{domainId}/declaration",
    method: "DELETE",
    operationId: "domain-abort-domain-declaration",
};
/** Check if a Domain is available to register. */
export const domainCheckDomainRegistrability = {
    path: "/v2/domain-registrable",
    method: "POST",
    operationId: "domain-check-domain-registrability",
};
/** Check if a Domain is available to transfer. */
export const domainCheckDomainTransferability = {
    path: "/v2/domain-transferable",
    method: "POST",
    operationId: "domain-check-domain-transferability",
};
/** Create an auth code for a Domains transfer-out process. */
export const domainCreateDomainAuthCode = {
    path: "/v2/domains/{domainId}/actions/auth-code",
    method: "POST",
    operationId: "domain-create-domain-auth-code",
};
/** Get a Domain. */
export const domainGetDomain = {
    path: "/v2/domains/{domainId}",
    method: "GET",
    operationId: "domain-get-domain",
};
/** Delete a Domain. */
export const domainDeleteDomain = {
    path: "/v2/domains/{domainId}",
    method: "DELETE",
    operationId: "domain-delete-domain",
};
/** Get the latest screenshot's FileReference belonging to a Domain. */
export const domainGetLatestScreenshot = {
    path: "/v2/domains/latest-screenshot",
    method: "GET",
    operationId: "domain-get-latest-screenshot",
};
/** List the contact schemas for a TLD. */
export const domainListTldContactSchemas = {
    path: "/v2/domain-tlds/{tld}/contact-schemas",
    method: "GET",
    operationId: "domain-list-tld-contact-schemas",
};
/** List TLDs. */
export const domainListTlds = {
    path: "/v2/domain-tlds",
    method: "GET",
    operationId: "domain-list-tlds",
};
/** Resend a Domain email. */
export const domainResendDomainEmail = {
    path: "/v2/domains/{domainId}/actions/resend-email",
    method: "POST",
    operationId: "domain-resend-domain-email",
};
/** Suggest a list of domains based on a prompt using AI. */
export const domainSuggest = {
    path: "/v2/domain-suggestions",
    method: "GET",
    operationId: "domain-suggest",
};
/** Update the auth code of a Domain. */
export const domainUpdateDomainAuthCode = {
    path: "/v2/domains/{domainId}/auth-code",
    method: "PATCH",
    operationId: "domain-update-domain-auth-code",
};
/** Update a contact of a Domain. */
export const domainUpdateDomainContact = {
    path: "/v2/domains/{domainId}/contacts/{contact}",
    method: "PATCH",
    operationId: "domain-update-domain-contact",
};
/** Update a Domain's project id. */
export const domainUpdateDomainProjectId = {
    path: "/v2/domains/{domainId}/project-id",
    method: "PATCH",
    operationId: "domain-update-domain-project-id",
};
/** Authenticate your external application using the extensionInstanceSecret. */
export const extensionAuthenticateInstance = {
    path: "/v2/extension-instances/{extensionInstanceId}/tokens",
    method: "POST",
    operationId: "extension-authenticate-instance",
};
/** Authenticate your external application using a session token and an extension secret */
export const extensionAuthenticateWithSessionToken = {
    path: "/v2/authenticate-session-token",
    method: "POST",
    operationId: "extension-authenticate-with-session-token",
};
/** Schedule an Extension Instance Termination for the next possible date. */
export const extensionScheduleExtensionTermination = {
    path: "/v2/extension-instances/{extensionInstanceId}/termination",
    method: "POST",
    operationId: "extension-schedule-extension-termination",
};
/** Cancel an Extension Instance Termination. */
export const extensionCancelExtensionTermination = {
    path: "/v2/extension-instances/{extensionInstanceId}/termination",
    method: "DELETE",
    operationId: "extension-cancel-extension-termination",
};
/** Change the context of an Extension. */
export const extensionChangeContext = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/context",
    method: "PUT",
    operationId: "extension-change-context",
};
/** Consent to extension scopes. */
export const extensionConsentToExtensionScopes = {
    path: "/v2/extension-instances/{extensionInstanceId}/scopes",
    method: "PATCH",
    operationId: "extension-consent-to-extension-scopes",
};
/** Create the OnboardingProcess of a Contributor. */
export const extensionCreateContributorOnboardingProcess = {
    path: "/v2/contributors/{contributorId}/onboarding-process",
    method: "POST",
    operationId: "extension-create-contributor-onboarding-process",
};
/** List ExtensionInstances. */
export const extensionListExtensionInstances = {
    path: "/v2/extension-instances",
    method: "GET",
    operationId: "extension-list-extension-instances",
};
/** Create an ExtensionInstance. */
export const extensionCreateExtensionInstance = {
    path: "/v2/extension-instances",
    method: "POST",
    operationId: "extension-create-extension-instance",
};
/** Create an access token retrieval key for an extension instance. */
export const extensionCreateRetrievalKey = {
    path: "/v2/extension-instances/{extensionInstanceId}/actions/create-access-token-retrieval-key",
    method: "POST",
    operationId: "extension-create-retrieval-key",
};
/** Get an ExtensionInstance. */
export const extensionGetExtensionInstance = {
    path: "/v2/extension-instances/{extensionInstanceId}",
    method: "GET",
    operationId: "extension-get-extension-instance",
};
/** Delete a free ExtensionInstance. If the Extension is chargable the contract must be terminated instead. */
export const extensionDeleteExtensionInstance = {
    path: "/v2/extension-instances/{extensionInstanceId}",
    method: "DELETE",
    operationId: "extension-delete-extension-instance",
};
/** Get Extension of own contributor. */
export const extensionGetOwnExtension = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}",
    method: "GET",
    operationId: "extension-get-own-extension",
};
/** Delete an extension. */
export const extensionDeleteExtension = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}",
    method: "DELETE",
    operationId: "extension-delete-extension",
};
/** Patch Extension. */
export const extensionPatchExtension = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}",
    method: "PATCH",
    operationId: "extension-patch-extension",
};
/** Disable an ExtensionInstance. */
export const extensionDisableExtensionInstance = {
    path: "/v2/extension-instances/{extensionInstanceId}/actions/disable",
    method: "POST",
    operationId: "extension-disable-extension-instance",
};
/** Dry run a webhook with random or given values. */
export const extensionDryRunWebhook = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/extension-instances/{extensionInstanceId}/actions/dry-run/{webhookKind}",
    method: "POST",
    operationId: "extension-dry-run-webhook",
};
/** Enable an ExtensionInstance. */
export const extensionEnableExtensionInstance = {
    path: "/v2/extension-instances/{extensionInstanceId}/actions/enable",
    method: "POST",
    operationId: "extension-enable-extension-instance",
};
/** Generate an Extension secret for the given Extension. */
export const extensionGenerateExtensionSecret = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/secret",
    method: "POST",
    operationId: "extension-generate-extension-secret",
};
/** Generate a session token to transmit it to the extensions frontend fragment. */
export const extensionGenerateSessionToken = {
    path: "/v2/extension-instances/{extensionInstanceId}/sessions/{sessionId}",
    method: "POST",
    operationId: "extension-generate-session-token",
};
/** Get a Contributor. */
export const extensionGetContributor = {
    path: "/v2/contributors/{contributorId}",
    method: "GET",
    operationId: "extension-get-contributor",
};
/** Get all open extension orders for given customer */
export const extensionGetCustomerExtensionInstanceOrders = {
    path: "/v2/customers/{customerId}/extension-orders",
    method: "GET",
    operationId: "extension-get-customer-extension-instance-orders",
};
/** Get the Contract Strategy of an Extension Instance */
export const extensionGetExtensionInstanceContract = {
    path: "/v2/extension-instances/{extensionInstanceId}/contract",
    method: "GET",
    operationId: "extension-get-extension-instance-contract",
};
/** Update or Create Contract for existing Extension Instances. */
export const extensionUpdateExtensionInstanceContract = {
    path: "/v2/extension-instances/{extensionInstanceId}/contract",
    method: "PUT",
    operationId: "extension-update-extension-instance-contract",
};
/** Get the ExtensionInstance of a specific customer and extension, if existing. */
export const extensionGetExtensionInstanceForCustomer = {
    path: "/v2/customers/{customerId}/extensions/{extensionId}",
    method: "GET",
    operationId: "extension-get-extension-instance-for-customer",
};
/** Get the ExtensionInstance of a specific project and extension, if existing. */
export const extensionGetExtensionInstanceForProject = {
    path: "/v2/projects/{projectId}/extensions/{extensionId}",
    method: "GET",
    operationId: "extension-get-extension-instance-for-project",
};
/** Get an Extension. */
export const extensionGetExtension = {
    path: "/v2/extensions/{extensionId}",
    method: "GET",
    operationId: "extension-get-extension",
};
/** Get all open extension orders for given project */
export const extensionGetProjectExtensionInstanceOrders = {
    path: "/v2/projects/{projectId}/extension-orders",
    method: "GET",
    operationId: "extension-get-project-extension-instance-orders",
};
/** Get the public key to verify the webhook signature. */
export const extensionGetPublicKey = {
    path: "/v2/public-keys/{serial}",
    method: "GET",
    operationId: "extension-get-public-key",
};
/** Invalidate the given Extension secret immediately. */
export const extensionInvalidateExtensionSecret = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/secret/{extensionSecretId}",
    method: "DELETE",
    operationId: "extension-invalidate-extension-secret",
};
/** List Contributors. */
export const extensionListContributors = {
    path: "/v2/contributors",
    method: "GET",
    operationId: "extension-list-contributors",
};
/** List Extensions. */
export const extensionListExtensions = {
    path: "/v2/extensions",
    method: "GET",
    operationId: "extension-list-extensions",
};
/** List Extensions of own contributor. */
export const extensionListOwnExtensions = {
    path: "/v2/contributors/{contributorId}/extensions",
    method: "GET",
    operationId: "extension-list-own-extensions",
};
/** Register an Extension. */
export const extensionRegisterExtension = {
    path: "/v2/contributors/{contributorId}/extensions",
    method: "POST",
    operationId: "extension-register-extension",
};
/** List Scopes. */
export const extensionListScopes = {
    path: "/v2/scopes",
    method: "GET",
    operationId: "extension-list-scopes",
};
/** Order Extension with saved payment method */
export const extensionOrderExtension = {
    path: "/v2/extensions/{extensionId}/order",
    method: "POST",
    operationId: "extension-order-extension",
};
/** Remove an asset of an extension. */
export const extensionRemoveAsset = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/assets/{assetRefId}",
    method: "DELETE",
    operationId: "extension-remove-asset",
};
/** Add a logo to an extension. */
export const extensionRequestLogoUpload = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/logo",
    method: "POST",
    operationId: "extension-request-logo-upload",
};
/** Remove the logo of an extension. */
export const extensionRemoveLogo = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/logo",
    method: "DELETE",
    operationId: "extension-remove-logo",
};
/** Add an asset to an extension. */
export const extensionRequestAssetUpload = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/assets",
    method: "POST",
    operationId: "extension-request-asset-upload",
};
/** Start the verification process of an Extension. */
export const extensionRequestExtensionVerification = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/verification-process",
    method: "POST",
    operationId: "extension-request-extension-verification",
};
/** Publish or withdraw an Extension. */
export const extensionSetExtensionPublishedState = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/published",
    method: "PUT",
    operationId: "extension-set-extension-published-state",
};
/** Start a checkout process for an extension. */
export const extensionStartExtensionCheckout = {
    path: "/v2/extensions/{extensionId}/checkout",
    method: "POST",
    operationId: "extension-start-extension-checkout",
};
/** Creates or Updates Pricing for an Extension. */
export const extensionUpdateExtensionPricing = {
    path: "/v2/contributors/{contributorId}/extensions/{extensionId}/pricing",
    method: "PUT",
    operationId: "extension-update-extension-pricing",
};
/** Create a File. */
export const fileCreateFile = {
    path: "/v2/files",
    method: "POST",
    operationId: "file-create-file",
};
/** Get a File's meta. */
export const fileGetFileMeta = {
    path: "/v2/files/{fileId}/meta",
    method: "GET",
    operationId: "file-get-file-meta",
};
/** Get a FileUploadToken's rules. */
export const fileGetFileUploadTokenRules = {
    path: "/v2/file-upload-tokens/{fileUploadToken}/rules",
    method: "GET",
    operationId: "file-get-file-upload-token-rules",
};
/** Get a FileUploadType's rules. */
export const fileGetFileUploadTypeRules = {
    path: "/v2/file-upload-types/{fileUploadType}/rules",
    method: "GET",
    operationId: "file-get-file-upload-type-rules",
};
/** Get a File. */
export const fileGetFile = {
    path: "/v2/files/{fileId}",
    method: "GET",
    operationId: "file-get-file",
};
/** Get a File with user-friendly url. */
export const fileGetFileWithName = {
    path: "/v2/files/{fileId}/{fileName}",
    method: "GET",
    operationId: "file-get-file-with-name",
};
/** List Ingresses. */
export const ingressListIngresses = {
    path: "/v2/ingresses",
    method: "GET",
    operationId: "ingress-list-ingresses",
};
/** Create an Ingress. */
export const ingressCreateIngress = {
    path: "/v2/ingresses",
    method: "POST",
    operationId: "ingress-create-ingress",
};
/** Get an Ingress. */
export const ingressGetIngress = {
    path: "/v2/ingresses/{ingressId}",
    method: "GET",
    operationId: "ingress-get-ingress",
};
/** Delete an Ingress. */
export const ingressDeleteIngress = {
    path: "/v2/ingresses/{ingressId}",
    method: "DELETE",
    operationId: "ingress-delete-ingress",
};
/** Verifiy the ownership of an Ingress. */
export const ingressIngressVerifyOwnership = {
    path: "/v2/ingresses/{ingressId}/actions/verify-ownership",
    method: "POST",
    operationId: "ingress-ingress-verify-ownership",
};
/** List Ingresses compatible with a certificate. */
export const ingressListIngressesCompatibleWithCertificate = {
    path: "/v2/actions/list-ingresses-compatible-with-certificate",
    method: "POST",
    operationId: "ingress-list-ingresses-compatible-with-certificate",
};
/** Request the ACME certificate issuance of an Ingress. */
export const ingressRequestIngressAcmeCertificateIssuance = {
    path: "/v2/ingresses/{ingressId}/actions/request-acme-certificate-issuance",
    method: "POST",
    operationId: "ingress-request-ingress-acme-certificate-issuance",
};
/** Get details of an Invoice. */
export const invoiceDetail = {
    path: "/v2/invoices/{invoiceId}",
    method: "GET",
    operationId: "invoice-detail",
};
/** Get InvoiceSettings of a Customer. */
export const invoiceGetDetailOfInvoiceSettings = {
    path: "/v2/customers/{customerId}/invoice-settings",
    method: "GET",
    operationId: "invoice-get-detail-of-invoice-settings",
};
/** Update InvoiceSettings of a Customer. */
export const invoiceUpdateInvoiceSettings = {
    path: "/v2/customers/{customerId}/invoice-settings",
    method: "PUT",
    operationId: "invoice-update-invoice-settings",
};
/** Request an Access Token for the Invoice file. */
export const invoiceGetFileAccessToken = {
    path: "/v2/customers/{customerId}/invoices/{invoiceId}/file-access-token",
    method: "GET",
    operationId: "invoice-get-file-access-token",
};
/** List Invoices of a Customer. */
export const invoiceListCustomerInvoices = {
    path: "/v2/customers/{customerId}/invoices",
    method: "GET",
    operationId: "invoice-list-customer-invoices",
};
/** List DeliveryBoxes belonging to a Project. */
export const mailListDeliveryBoxes = {
    path: "/v2/projects/{projectId}/delivery-boxes",
    method: "GET",
    operationId: "mail-list-delivery-boxes",
};
/** Create a DeliveryBox. */
export const mailCreateDeliverybox = {
    path: "/v2/projects/{projectId}/delivery-boxes",
    method: "POST",
    operationId: "mail-create-deliverybox",
};
/** List MailAddresses belonging to a Project. */
export const mailListMailAddresses = {
    path: "/v2/projects/{projectId}/mail-addresses",
    method: "GET",
    operationId: "mail-list-mail-addresses",
};
/** Create a MailAddress. */
export const mailCreateMailAddress = {
    path: "/v2/projects/{projectId}/mail-addresses",
    method: "POST",
    operationId: "mail-create-mail-address",
};
/** Get a DeliveryBox. */
export const mailGetDeliveryBox = {
    path: "/v2/delivery-boxes/{deliveryBoxId}",
    method: "GET",
    operationId: "mail-get-delivery-box",
};
/** Delete a DeliveryBox. */
export const mailDeleteDeliveryBox = {
    path: "/v2/delivery-boxes/{deliveryBoxId}",
    method: "DELETE",
    operationId: "mail-delete-delivery-box",
};
/** Get a MailAddress. */
export const mailGetMailAddress = {
    path: "/v2/mail-addresses/{mailAddressId}",
    method: "GET",
    operationId: "mail-get-mail-address",
};
/** Delete a MailAddress. */
export const mailDeleteMailAddress = {
    path: "/v2/mail-addresses/{mailAddressId}",
    method: "DELETE",
    operationId: "mail-delete-mail-address",
};
/** List mail settings of a Project. */
export const mailListProjectMailSettings = {
    path: "/v2/projects/{projectId}/mail-settings",
    method: "GET",
    operationId: "mail-list-project-mail-settings",
};
/** Update the description of a DeliveryBox. */
export const mailUpdateDeliveryBoxDescription = {
    path: "/v2/delivery-boxes/{deliveryBoxId}/description",
    method: "PATCH",
    operationId: "mail-update-delivery-box-description",
};
/** Update the password of a DeliveryBox. */
export const mailUpdateDeliveryBoxPassword = {
    path: "/v2/delivery-boxes/{deliveryBoxId}/password",
    method: "PATCH",
    operationId: "mail-update-delivery-box-password",
};
/** Update a MailAddress. */
export const mailUpdateMailAddressAddress = {
    path: "/v2/mail-addresses/{mailAddressId}/address",
    method: "PATCH",
    operationId: "mail-update-mail-address-address",
};
/** Update the catch-all of a MailAddress. */
export const mailUpdateMailAddressCatchAll = {
    path: "/v2/mail-addresses/{mailAddressId}/catch-all",
    method: "PATCH",
    operationId: "mail-update-mail-address-catch-all",
};
/** Update a mail setting of a Project. */
export const mailUpdateProjectMailSetting = {
    path: "/v2/projects/{projectId}/mail-settings/{mailSetting}",
    method: "PATCH",
    operationId: "mail-update-project-mail-setting",
};
/** Get payment method details */
export const marketplaceCustomerGetPaymentMethod = {
    path: "/v2/customers/{customerId}/payment-method",
    method: "GET",
    operationId: "marketplace-customer-get-payment-method",
};
/** Get the link to update the marketplace payment method */
export const marketplaceCustomerUpdatePaymentMethod = {
    path: "/v2/customers/{customerId}/payment-method",
    method: "PUT",
    operationId: "marketplace-customer-update-payment-method",
};
/** Getting the subscription status of the subscription. */
export const newsletterGetInfo = {
    path: "/v2/newsletter-subscriptions/self",
    method: "GET",
    operationId: "newsletter-get-info",
};
/** Unsubscribe a user from the mStudio newsletter. */
export const newsletterUnsubscribeUser = {
    path: "/v2/newsletter-subscriptions/self",
    method: "DELETE",
    operationId: "newsletter-unsubscribe-user",
};
/** Get the counts for unread notifications of the user. */
export const notificationsCountUnreadNotifications = {
    path: "/v2/notification-unread-counts",
    method: "GET",
    operationId: "notifications-count-unread-notifications",
};
/** List all unread notifications. */
export const notificationsListNotifications = {
    path: "/v2/notifications",
    method: "GET",
    operationId: "notifications-list-notifications",
};
/** Mark all notifications as read. */
export const notificationsReadAllNotifications = {
    path: "/v2/notifications/actions/read-all",
    method: "POST",
    operationId: "notifications-read-all-notifications",
};
/** Mark notification as read. */
export const notificationsReadNotification = {
    path: "/v2/notifications/{notificationId}/status",
    method: "PUT",
    operationId: "notifications-read-notification",
};
/** Get list of Orders. */
export const orderListOrders = {
    path: "/v2/orders",
    method: "GET",
    operationId: "order-list-orders",
};
/** Create an Order. */
export const orderCreateOrder = {
    path: "/v2/orders",
    method: "POST",
    operationId: "order-create-order",
};
/** Create TariffChange Order. */
export const orderCreateTariffChange = {
    path: "/v2/tariff-changes",
    method: "POST",
    operationId: "order-create-tariff-change",
};
/** Get Order for Customer. */
export const orderGetOrder = {
    path: "/v2/orders/{orderId}",
    method: "GET",
    operationId: "order-get-order",
};
/** Get list of Orders of a Customer. */
export const orderListCustomerOrders = {
    path: "/v2/customers/{customerId}/orders",
    method: "GET",
    operationId: "order-list-customer-orders",
};
/** Get list of Orders of a Project. */
export const orderListProjectOrders = {
    path: "/v2/projects/{projectId}/orders",
    method: "GET",
    operationId: "order-list-project-orders",
};
/** Preview Order. */
export const orderPreviewOrder = {
    path: "/v2/order-previews",
    method: "POST",
    operationId: "order-preview-order",
};
/** Preview TariffChange. */
export const orderPreviewTariffChange = {
    path: "/v2/tariff-change-previews",
    method: "POST",
    operationId: "order-preview-tariff-change",
};
/** Get detailed performance data for a given domain and path. */
export const pageinsightsGetPerformanceData = {
    path: "/v2/page-insights",
    method: "GET",
    operationId: "pageinsights-get-performance-data",
};
/** Get all data for a given strace. */
export const pageinsightsGetStraceData = {
    path: "/v2/projects/{projectId}/straces/{straceId}",
    method: "GET",
    operationId: "pageinsights-get-strace-data",
};
/** List websites (specified as domain and path) from a project where performance data is available. */
export const pageinsightsListPerformanceDataForProject = {
    path: "/v2/projects/{projectId}/page-insights",
    method: "GET",
    operationId: "pageinsights-list-performance-data-for-project",
};
/** Schedule a strace measurement for a single http request. */
export const pageinsightsScheduleStrace = {
    path: "/v2/projects/{projectId}/straces",
    method: "POST",
    operationId: "pageinsights-schedule-strace",
};
/** Get a PasswordPolicy. */
export const passwordValidationGetPasswordPolicy = {
    path: "/v2/password-policies/{passwordPolicy}",
    method: "GET",
    operationId: "password-validation-get-password-policy",
};
/** Accept a ProjectInvite. */
export const projectAcceptProjectInvite = {
    path: "/v2/project-invites/{projectInviteId}/actions/accept",
    method: "POST",
    operationId: "project-accept-project-invite",
};
/** List Invites belonging to a Project. */
export const projectListInvitesForProject = {
    path: "/v2/projects/{projectId}/invites",
    method: "GET",
    operationId: "project-list-invites-for-project",
};
/** Create a ProjectInvite. */
export const projectCreateProjectInvite = {
    path: "/v2/projects/{projectId}/invites",
    method: "POST",
    operationId: "project-create-project-invite",
};
/** Create a Project belonging to a Server. */
export const projectCreateProject = {
    path: "/v2/servers/{serverId}/projects",
    method: "POST",
    operationId: "project-create-project",
};
/** Decline a ProjectInvite. */
export const projectDeclineProjectInvite = {
    path: "/v2/project-invites/{projectInviteId}/actions/decline",
    method: "POST",
    operationId: "project-decline-project-invite",
};
/** Request a Project avatar upload. */
export const projectRequestProjectAvatarUpload = {
    path: "/v2/projects/{projectId}/avatar",
    method: "POST",
    operationId: "project-request-project-avatar-upload",
};
/** Delete a Project's avatar. */
export const projectDeleteProjectAvatar = {
    path: "/v2/projects/{projectId}/avatar",
    method: "DELETE",
    operationId: "project-delete-project-avatar",
};
/** Get a ProjectInvite. */
export const projectGetProjectInvite = {
    path: "/v2/project-invites/{projectInviteId}",
    method: "GET",
    operationId: "project-get-project-invite",
};
/** Delete a ProjectInvite. */
export const projectDeleteProjectInvite = {
    path: "/v2/project-invites/{projectInviteId}",
    method: "DELETE",
    operationId: "project-delete-project-invite",
};
/** Get a ProjectMembership */
export const projectGetProjectMembership = {
    path: "/v2/project-memberships/{projectMembershipId}",
    method: "GET",
    operationId: "project-get-project-membership",
};
/** Delete a ProjectMembership. */
export const projectDeleteProjectMembership = {
    path: "/v2/project-memberships/{projectMembershipId}",
    method: "DELETE",
    operationId: "project-delete-project-membership",
};
/** Update a ProjectMembership. */
export const projectUpdateProjectMembership = {
    path: "/v2/project-memberships/{projectMembershipId}",
    method: "PATCH",
    operationId: "project-update-project-membership",
};
/** Get a Project. */
export const projectGetProject = {
    path: "/v2/projects/{projectId}",
    method: "GET",
    operationId: "project-get-project",
};
/** Delete a Project. */
export const projectDeleteProject = {
    path: "/v2/projects/{projectId}",
    method: "DELETE",
    operationId: "project-delete-project",
};
/** Request a Server avatar upload. */
export const projectRequestServerAvatarUpload = {
    path: "/v2/servers/{serverId}/avatar",
    method: "POST",
    operationId: "project-request-server-avatar-upload",
};
/** Delete a Server's avatar. */
export const projectDeleteServerAvatar = {
    path: "/v2/servers/{serverId}/avatar",
    method: "DELETE",
    operationId: "project-delete-server-avatar",
};
/** List directories belonging to a Project. */
export const projectFileSystemGetDirectories = {
    path: "/v2/projects/{projectId}/filesystem-directories",
    method: "GET",
    operationId: "project-file-system-get-directories",
};
/** Get a Project directory filesystem usage. */
export const projectFileSystemGetDiskUsage = {
    path: "/v2/projects/{projectId}/filesystem-disk-usage",
    method: "GET",
    operationId: "project-file-system-get-disk-usage",
};
/** Get a Project file's content. */
export const projectFileSystemGetFileContent = {
    path: "/v2/projects/{projectId}/filesystem-file-content",
    method: "GET",
    operationId: "project-file-system-get-file-content",
};
/** Get a Project's file/filesystem authorization token. */
export const projectFileSystemGetJwt = {
    path: "/v2/projects/{projectId}/jwt",
    method: "GET",
    operationId: "project-file-system-get-jwt",
};
/** Get a Project file's information. */
export const projectFileSystemListFiles = {
    path: "/v2/projects/{projectId}/filesystem-files",
    method: "GET",
    operationId: "project-file-system-list-files",
};
/** Get a ProjectInvite by token. */
export const projectGetProjectTokenInvite = {
    path: "/v2/project-token-invite",
    method: "GET",
    operationId: "project-get-project-token-invite",
};
/** Get the executing user's membership in a Project. */
export const projectGetSelfMembershipForProject = {
    path: "/v2/projects/{projectId}/memberships/self",
    method: "GET",
    operationId: "project-get-self-membership-for-project",
};
/** Get a Server. */
export const projectGetServer = {
    path: "/v2/servers/{serverId}",
    method: "GET",
    operationId: "project-get-server",
};
/** List Memberships belonging to a Project. */
export const projectListMembershipsForProject = {
    path: "/v2/projects/{projectId}/memberships",
    method: "GET",
    operationId: "project-list-memberships-for-project",
};
/** List ProjectInvites belonging to the executing user. */
export const projectListProjectInvites = {
    path: "/v2/project-invites",
    method: "GET",
    operationId: "project-list-project-invites",
};
/** List ProjectMemberships belonging to the executing user. */
export const projectListProjectMemberships = {
    path: "/v2/project-memberships",
    method: "GET",
    operationId: "project-list-project-memberships",
};
/** List Projects belonging to the executing user. */
export const projectListProjects = {
    path: "/v2/projects",
    method: "GET",
    operationId: "project-list-projects",
};
/** List Servers belonging to the executing user. */
export const projectListServers = {
    path: "/v2/servers",
    method: "GET",
    operationId: "project-list-servers",
};
/** Resend the mail for a ProjectInvite. */
export const projectResendProjectInviteMail = {
    path: "/v2/project-invites/{projectInviteId}/actions/resend",
    method: "POST",
    operationId: "project-resend-project-invite-mail",
};
/** Update a Project's description. */
export const projectUpdateProjectDescription = {
    path: "/v2/projects/{projectId}/description",
    method: "PATCH",
    operationId: "project-update-project-description",
};
/** Update a Servers's description. */
export const projectUpdateServerDescription = {
    path: "/v2/servers/{serverId}/description",
    method: "PATCH",
    operationId: "project-update-server-description",
};
/** Register a tariff change for a legacy tariff. */
export const relocationCreateLegacyTariffChange = {
    path: "/v2/legacy-tariff-change",
    method: "POST",
    operationId: "relocation-create-legacy-tariff-change",
};
/** Relocate an external Project to mittwald. */
export const relocationCreateRelocation = {
    path: "/v2/relocation",
    method: "POST",
    operationId: "relocation-create-relocation",
};
/** Obtain a service token. */
export const servicetokenAuthenticateService = {
    path: "/v2/services/{accessKeyId}/actions/authenticate",
    method: "POST",
    operationId: "servicetoken-authenticate-service",
};
/** Get all SFTPUsers for a Project. */
export const sftpUserListSftpUsers = {
    path: "/v2/projects/{projectId}/sftp-users",
    method: "GET",
    operationId: "sftp-user-list-sftp-users",
};
/** Create an SFTPUser for a Project. */
export const sftpUserCreateSftpUser = {
    path: "/v2/projects/{projectId}/sftp-users",
    method: "POST",
    operationId: "sftp-user-create-sftp-user",
};
/** Get an SFTPUser. */
export const sftpUserGetSftpUser = {
    path: "/v2/sftp-users/{sftpUserId}",
    method: "GET",
    operationId: "sftp-user-get-sftp-user",
};
/** Delete an SFTPUser. */
export const sftpUserDeleteSftpUser = {
    path: "/v2/sftp-users/{sftpUserId}",
    method: "DELETE",
    operationId: "sftp-user-delete-sftp-user",
};
/** Update an SFTPUser. */
export const sftpUserUpdateSftpUser = {
    path: "/v2/sftp-users/{sftpUserId}",
    method: "PATCH",
    operationId: "sftp-user-update-sftp-user",
};
/** Get all SSHUsers for a Project. */
export const sshUserListSshUsers = {
    path: "/v2/projects/{projectId}/ssh-users",
    method: "GET",
    operationId: "ssh-user-list-ssh-users",
};
/** Create an SSHUser for a Project. */
export const sshUserCreateSshUser = {
    path: "/v2/projects/{projectId}/ssh-users",
    method: "POST",
    operationId: "ssh-user-create-ssh-user",
};
/** Get an SSHUser. */
export const sshUserGetSshUser = {
    path: "/v2/ssh-users/{sshUserId}",
    method: "GET",
    operationId: "ssh-user-get-ssh-user",
};
/** Delete an SSHUser. */
export const sshUserDeleteSshUser = {
    path: "/v2/ssh-users/{sshUserId}",
    method: "DELETE",
    operationId: "ssh-user-delete-ssh-user",
};
/** Update an SSHUser. */
export const sshUserUpdateSshUser = {
    path: "/v2/ssh-users/{sshUserId}",
    method: "PATCH",
    operationId: "ssh-user-update-ssh-user",
};
/** Check the replacement of a Certificate. */
export const sslCheckReplaceCertificate = {
    path: "/v2/certificates/{certificateId}/actions/check-replace-certificate",
    method: "POST",
    operationId: "ssl-check-replace-certificate",
};
/** List CertificateRequests belonging to a Project or an Ingress. */
export const sslListCertificateRequests = {
    path: "/v2/certificate-requests",
    method: "GET",
    operationId: "ssl-list-certificate-requests",
};
/** Create a CertificateRequest. */
export const sslCreateCertificateRequest = {
    path: "/v2/certificate-requests",
    method: "POST",
    operationId: "ssl-create-certificate-request",
};
/** Delete a CertificateRequest. */
export const sslDeleteCertificateRequest = {
    path: "/v2/certificate-request/{certificateRequestId}",
    method: "DELETE",
    operationId: "ssl-delete-certificate-request",
};
/** Delete a Certificate. */
export const sslDeleteCertificate = {
    path: "/v2/certificate/{certificateId}",
    method: "DELETE",
    operationId: "ssl-delete-certificate",
};
/** Get a CertificateRequest. */
export const sslGetCertificateRequest = {
    path: "/v2/certificate-requests/{certificateRequestId}",
    method: "GET",
    operationId: "ssl-get-certificate-request",
};
/** Get a Certificate. */
export const sslGetCertificate = {
    path: "/v2/certificates/{certificateId}",
    method: "GET",
    operationId: "ssl-get-certificate",
};
/** Update a Certificate. */
export const sslReplaceCertificate = {
    path: "/v2/certificates/{certificateId}",
    method: "PUT",
    operationId: "ssl-replace-certificate",
};
/** List Certificates belonging to a Project or an Ingress. */
export const sslListCertificates = {
    path: "/v2/certificates",
    method: "GET",
    operationId: "ssl-list-certificates",
};
/** Get storage space Statistics belonging to a Project. */
export const storagespaceGetProjectStatistics = {
    path: "/v2/projects/{projectId}/storage-space-statistics",
    method: "GET",
    operationId: "storagespace-get-project-statistics",
};
/** Get storage space Statistics belonging to a Server. */
export const storagespaceGetServerStatistics = {
    path: "/v2/servers/{serverId}/storage-space-statistics",
    method: "GET",
    operationId: "storagespace-get-server-statistics",
};
/** Update a Project's storage space notification threshold. */
export const storagespaceReplaceProjectNotificationThreshold = {
    path: "/v2/projects/{projectId}/storage-space-notification-threshold",
    method: "PUT",
    operationId: "storagespace-replace-project-notification-threshold",
};
/** Update a Server's storage space notification threshold. */
export const storagespaceReplaceServerNotificationThreshold = {
    path: "/v2/servers/{serverId}/storage-space-notification-threshold",
    method: "PUT",
    operationId: "storagespace-replace-server-notification-threshold",
};
/** Add phone number and start verification process. */
export const userAddPhoneNumber = {
    path: "/v2/users/{userId}/phone",
    method: "POST",
    operationId: "user-add-phone-number",
};
/** Remove phone number. */
export const userRemovePhoneNumber = {
    path: "/v2/users/{userId}/phone",
    method: "DELETE",
    operationId: "user-remove-phone-number",
};
/** Validate your second factor. */
export const userAuthenticateMfa = {
    path: "/v2/authenticate-mfa",
    method: "POST",
    operationId: "user-authenticate-mfa",
};
/** Authenticate yourself to get an access token. */
export const userAuthenticate = {
    path: "/v2/authenticate",
    method: "POST",
    operationId: "user-authenticate",
};
/** Authenticate an user with an access token retrieval key. */
export const userAuthenticateWithAccessTokenRetrievalKey = {
    path: "/v2/authenticate-token-retrieval-key",
    method: "POST",
    operationId: "user-authenticate-with-access-token-retrieval-key",
};
/** Get your verified Email-Address. */
export const userGetOwnEmail = {
    path: "/v2/users/self/credentials/email",
    method: "GET",
    operationId: "user-get-own-email",
};
/** Change your Email-Address. */
export const userChangeEmail = {
    path: "/v2/users/self/credentials/email",
    method: "PUT",
    operationId: "user-change-email",
};
/** Change your password. */
export const userChangePassword = {
    path: "/v2/users/self/credentials/password",
    method: "PUT",
    operationId: "user-change-password",
};
/** Check token for validity. */
export const userCheckToken = {
    path: "/v2/users/self/credentials/token",
    method: "POST",
    operationId: "user-check-token",
};
/** Get your current multi factor auth status. */
export const userGetMfaStatus = {
    path: "/v2/users/self/credentials/mfa",
    method: "GET",
    operationId: "user-get-mfa-status",
};
/** Reset RecoveryCodes for MFA. */
export const userResetRecoverycodes = {
    path: "/v2/users/self/credentials/mfa",
    method: "PUT",
    operationId: "user-reset-recoverycodes",
};
/** Confirm Multi Factor Authentication. */
export const userConfirmMfa = {
    path: "/v2/users/self/credentials/mfa",
    method: "POST",
    operationId: "user-confirm-mfa",
};
/** Disable Multi Factor Authentication. */
export const userDisableMfa = {
    path: "/v2/users/self/credentials/mfa",
    method: "DELETE",
    operationId: "user-disable-mfa",
};
/** Confirm password reset. */
export const userConfirmPasswordReset = {
    path: "/v2/users/self/credentials/password/confirm-reset",
    method: "POST",
    operationId: "user-confirm-password-reset",
};
/** List all of your ApiTokens. */
export const userListApiTokens = {
    path: "/v2/users/self/api-tokens",
    method: "GET",
    operationId: "user-list-api-tokens",
};
/** Store a new ApiToken. */
export const userCreateApiToken = {
    path: "/v2/users/self/api-tokens",
    method: "POST",
    operationId: "user-create-api-token",
};
/** Submit your user feedback. */
export const userCreateFeedback = {
    path: "/v2/users/self/feedback",
    method: "POST",
    operationId: "user-create-feedback",
};
/** Get your stored ssh-keys. */
export const userListSshKeys = {
    path: "/v2/users/self/ssh-keys",
    method: "GET",
    operationId: "user-list-ssh-keys",
};
/** Store a new ssh-key. */
export const userCreateSshKey = {
    path: "/v2/users/self/ssh-keys",
    method: "POST",
    operationId: "user-create-ssh-key",
};
/** Get a specific ApiToken. */
export const userGetApiToken = {
    path: "/v2/users/self/api-tokens/{apiTokenId}",
    method: "GET",
    operationId: "user-get-api-token",
};
/** Update an existing `ApiToken`. */
export const userEditApiToken = {
    path: "/v2/users/self/api-tokens/{apiTokenId}",
    method: "PUT",
    operationId: "user-edit-api-token",
};
/** Deletes an ApiToken. */
export const userDeleteApiToken = {
    path: "/v2/users/self/api-tokens/{apiTokenId}",
    method: "DELETE",
    operationId: "user-delete-api-token",
};
/** Get a specific stored ssh-key. */
export const userGetSshKey = {
    path: "/v2/users/self/ssh-keys/{sshKeyId}",
    method: "GET",
    operationId: "user-get-ssh-key",
};
/** Edit a stored ssh-key. */
export const userEditSshKey = {
    path: "/v2/users/self/ssh-keys/{sshKeyId}",
    method: "PUT",
    operationId: "user-edit-ssh-key",
};
/** Remove a ssh-key. */
export const userDeleteSshKey = {
    path: "/v2/users/self/ssh-keys/{sshKeyId}",
    method: "DELETE",
    operationId: "user-delete-ssh-key",
};
/** Delete your account and all your personal data. */
export const userDeleteUser = {
    path: "/v2/users/self",
    method: "DELETE",
    operationId: "user-delete-user",
};
/** The timestamp of your latest password change. */
export const userGetPasswordUpdatedAt = {
    path: "/v2/users/self/credentials/password-updated-at",
    method: "GET",
    operationId: "user-get-password-updated-at",
};
/** Get personalized settings. */
export const userGetPersonalizedSettings = {
    path: "/v2/users/{userId}/settings",
    method: "GET",
    operationId: "user-get-personalized-settings",
};
/** Update personalized GUI settings. */
export const userUpdatePersonalizedSettings = {
    path: "/v2/users/{userId}/settings",
    method: "PUT",
    operationId: "user-update-personalized-settings",
};
/** Get poll settings for the specified user. */
export const userGetPollStatus = {
    path: "/v2/poll-settings/{userId}",
    method: "GET",
    operationId: "user-get-poll-status",
};
/** Store new or update poll settings. */
export const userPostPollStatus = {
    path: "/v2/poll-settings/{userId}",
    method: "POST",
    operationId: "user-post-poll-status",
};
/** Get a specific session. */
export const userGetSession = {
    path: "/v2/users/self/sessions/{tokenId}",
    method: "GET",
    operationId: "user-get-session",
};
/** Terminate a specific Session. */
export const userTerminateSession = {
    path: "/v2/users/self/sessions/{tokenId}",
    method: "DELETE",
    operationId: "user-terminate-session",
};
/** Get profile information for a user. */
export const userGetUser = {
    path: "/v2/users/{userId}",
    method: "GET",
    operationId: "user-get-user",
};
/** Change personal information. */
export const userUpdatePersonalInformation = {
    path: "/v2/users/{userId}",
    method: "PUT",
    operationId: "user-update-personal-information",
};
/** Initialize Multi Factor Authentication. If successful, it needs to be confirmed, before usage of mfa. */
export const userInitMfa = {
    path: "/v2/users/self/credentials/init-mfa",
    method: "POST",
    operationId: "user-init-mfa",
};
/** Initialize password reset process. */
export const userInitPasswordReset = {
    path: "/v2/users/self/credentials/actions/init-password-reset",
    method: "POST",
    operationId: "user-init-password-reset",
};
/** Submitted feedback of the given user. */
export const userListFeedback = {
    path: "/v2/users/{userId}/feedback",
    method: "GET",
    operationId: "user-list-feedback",
};
/** List all sessions. */
export const userListSessions = {
    path: "/v2/users/self/sessions",
    method: "GET",
    operationId: "user-list-sessions",
};
/** Refresh a session. */
export const userRefreshSession = {
    path: "/v2/users/self/sessions",
    method: "PUT",
    operationId: "user-refresh-session",
};
/** Terminate all sessions, except the current session. */
export const userTerminateAllSessions = {
    path: "/v2/users/self/sessions",
    method: "DELETE",
    operationId: "user-terminate-all-sessions",
};
/** Terminate session and invalidate access token. */
export const userLogout = {
    path: "/v2/logout",
    method: "PUT",
    operationId: "user-logout",
};
/** Obtain authorization from the resource owner. */
export const userOauthGetAuthorization = {
    path: "/v2/oauth2/authorize",
    method: "GET",
    operationId: "user-oauth-get-authorization",
};
/** Retrieve Access Token from Authorization Code. */
export const userOauthRetrieveAccessToken = {
    path: "/v2/oauth2/token",
    method: "POST",
    operationId: "user-oauth-retrieve-access-token",
};
/** Register with email and password. */
export const userRegister = {
    path: "/v2/register",
    method: "POST",
    operationId: "user-register",
};
/** Request a new avatar image upload. */
export const userRequestAvatarUpload = {
    path: "/v2/users/{userId}/avatar",
    method: "POST",
    operationId: "user-request-avatar-upload",
};
/** Remove Avatar. */
export const userRemoveAvatar = {
    path: "/v2/users/{userId}/avatar",
    method: "DELETE",
    operationId: "user-remove-avatar",
};
/** Resend the Email-Address verification email. */
export const userResendVerificationEmail = {
    path: "/v2/users/self/credentials/email/actions/resend-email",
    method: "POST",
    operationId: "user-resend-verification-email",
};
/** Request a support code. */
export const userSupportCodeRequest = {
    path: "/v2/users/self/credentials/support-code",
    method: "GET",
    operationId: "user-support-code-request",
};
/** Verify an added Email-Address. */
export const userVerifyEmail = {
    path: "/v2/users/self/credentials/email/actions/verify-email",
    method: "POST",
    operationId: "user-verify-email",
};
/** Verify phone number. */
export const userVerifyPhoneNumber = {
    path: "/v2/users/{userId}/actions/verify-phone",
    method: "POST",
    operationId: "user-verify-phone-number",
};
/** Verify your registration. */
export const userVerifyRegistration = {
    path: "/v2/verify-registration",
    method: "POST",
    operationId: "user-verify-registration",
};
/** Check if an address exists. */
export const verificationVerifyAddress = {
    path: "/v2/actions/verify-address",
    method: "POST",
    operationId: "verification-verify-address",
};
/** Check if a company exists. */
export const verificationVerifyCompany = {
    path: "/v2/actions/verify-company",
    method: "POST",
    operationId: "verification-verify-company",
};
/** Get cities in DACH. */
export const leadfyndrGetCities = {
    path: "/v2/cities",
    method: "GET",
    operationId: "leadfyndr-get-cities",
};
/** Reserve a unlocked lead for the given customerId. */
export const leadfyndrReserveUnlockedLead = {
    path: "/v2/customers/{customerId}/unlocked-leads/{leadId}/reservation",
    method: "POST",
    operationId: "leadfyndr-reserve-unlocked-lead",
};
/** Removes a reservation on a unlocked lead for the given customerId. */
export const leadfyndrRemoveUnlockedLeadReservation = {
    path: "/v2/customers/{customerId}/unlocked-leads/{leadId}/reservation",
    method: "DELETE",
    operationId: "leadfyndr-remove-unlocked-lead-reservation",
};
/** Get a simple lead. Use the unlocked route for more detail leads. */
export const leadfyndrGetLead = {
    path: "/v2/customers/{customerId}/leads/{leadId}",
    method: "GET",
    operationId: "leadfyndr-get-lead",
};
/** Get all leads. Use the unlocked routes for more lead details. */
export const leadfyndrListLeads = {
    path: "/v2/customers/{customerId}/leads",
    method: "GET",
    operationId: "leadfyndr-list-leads",
};
/** Get a detail of a unlocked lead. Organisation can unlock leads. */
export const leadfyndrGetUnlockedLead = {
    path: "/v2/customers/{customerId}/unlocked-leads/{leadId}",
    method: "GET",
    operationId: "leadfyndr-get-unlocked-lead",
};
/** Unlock a lead for the given customerId. */
export const leadfyndrUnlockLead = {
    path: "/v2/customers/{customerId}/unlocked-leads/{leadId}",
    method: "POST",
    operationId: "leadfyndr-unlock-lead",
};
/** Get all unlocked leads. Organisation can unlock leads. */
export const leadfyndrListUnlockedLeads = {
    path: "/v2/customers/{customerId}/unlocked-leads",
    method: "GET",
    operationId: "leadfyndr-list-unlocked-leads",
};
/** Get lead tariff options. How many leads did you unlock this month? */
export const leadfyndrGetLeadFyndrProfileTariffOptions = {
    path: "/v2/customers/{customerId}/lead-fyndr-profile/tariff",
    method: "GET",
    operationId: "leadfyndr-get-lead-fyndr-profile-tariff-options",
};
/** Get your LeadFyndr profile. */
export const leadfyndrGetLeadFyndrProfile = {
    path: "/v2/customers/{customerId}/lead-fyndr-profile",
    method: "GET",
    operationId: "leadfyndr-get-lead-fyndr-profile",
};
/** Get your LeadFyndr request. */
export const leadfyndrGetLeadFyndrProfileRequest = {
    path: "/v2/customers/{customerId}/lead-fyndr-profile-request",
    method: "GET",
    operationId: "leadfyndr-get-lead-fyndr-profile-request",
};
/** Create a new access request for LeadFyndr. */
export const leadfyndrCreateLeadFyndrAccessRequest = {
    path: "/v2/customers/{customerId}/lead-fyndr-profile-request",
    method: "POST",
    operationId: "leadfyndr-create-lead-fyndr-access-request",
};
/** Get a list of already created llm licences. */
export const projectGetLlmLicencesExperimental = {
    path: "/v2-experimental/projects/{projectId}/llm-licences",
    method: "GET",
    operationId: "project-get-llm-licences-experimental",
};
/** Creates a new llm beta Licence for a project. Will be purged on end of beta. */
export const projectCreateLlmBetaLicenceExperimental = {
    path: "/v2-experimental/projects/{projectId}/llm-licences",
    method: "POST",
    operationId: "project-create-llm-beta-licence-experimental",
};
/** Get a licence of a project. */
export const projectGetLlmLicenceExperimental = {
    path: "/v2-experimental/projects/{projectId}/llm-licences/{licenceId}",
    method: "GET",
    operationId: "project-get-llm-licence-experimental",
};
/** Update a llm Licence for a project. */
export const projectUpdateLlmLicenceExperimental = {
    path: "/v2-experimental/projects/{projectId}/llm-licences/{licenceId}",
    method: "PUT",
    operationId: "project-update-llm-licence-experimental",
};
/** Get a list of currently active llm models. */
export const miscGetLlmModelsExperimental = {
    path: "/v2-experimental/llm-models",
    method: "GET",
    operationId: "misc-get-llm-models-experimental",
};
